module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Manage Packages")]), _vm._v(" "), _vm._l((_vm.packages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "post full-width"
    }, [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v("\n           \n        "), _c('b', [_vm._v("$" + _vm._s(item.current_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "sml-btn blue",
      attrs: {
        "to": {
          path: '/admin/package/' + item.id
        }
      }
    }, [_vm._v("\n          Edit\n        ")])], 1)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a00d8a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/ManagePackages.vue
// module id = 481
// module chunks = 1